import React, { Component, useState } from "react";
import Filters from "./scheduleManageFilter";
import { lighten, makeStyles } from "@material-ui/core/styles";
import { Switch, Route, Link, BrowserRouter } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Table from "@material-ui/core/Table";
import Colors from "./../../Global/colors";
import Grid from "@material-ui/core/Grid";
import TableBody from "@material-ui/core/TableBody";
import List from "@material-ui/core/List";
import GlobalApi from "./../../Global";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import InputAdornment from "@material-ui/core/InputAdornment";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Typography from "@material-ui/core/Typography";
import Menu from "@material-ui/core/Menu";
import Popover from "@material-ui/core/Popover";
import swal from "@sweetalert/with-react";
import Checkbox from "@material-ui/core/Checkbox";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { CircularProgress } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import search from "../../Assets/search.png";
import help from '../../Assets/help_icon.png';
import helpAr from "../../Assets/help_icon_ar.png";
import refresh_token from "./../../Global/refresh_token";
import add from "../../Assets/add.png";
import filter from "../../Assets/Filter_Icon.png";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
// import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import {useTranslation} from 'react-i18next';

//Redux
import { useSelector, useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },
  visuallyHidden: {
    border: 0,
    clip: " t(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

function Schedulemanage() {
  const {t} = useTranslation();
  let company = useSelector((state) => state.companyReducer.company);
  const language = useSelector((state) => state.languageReducer.language);
  const classes = useStyles();
  const [state, setState] = useState({
    Schedule: [],
    filter_arr: null,
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [filterMenu1, setFilterMenu1] = React.useState(null);
  const [filterMenu2, setFilterMenu2] = React.useState(null);
  const [filterMenu3, setFilterMenu3] = React.useState(null);
  const [filterMenu4, setFilterMenu4] = React.useState(null);
  const [filterMenu5, setFilterMenu5] = React.useState(null);
  const [Assignees, setAssignees] = useState([]);
  const [AssigneBy, setAssignedBy] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroups] = useState([]);
  const [sites, setSites] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [userFilter, setUserFilter] = useState("");
  const [assignedByFilter, setAssignedByFilter] = useState("");
  const [templateFilter, setTemplateFilter] = useState("");
  const [siteFilter, setSiteFilter] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedAssigners, setSelectedAssigners] = useState([]);
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  const [appliedFilters, setAppliedFilters]=useState({
    Assignees:false,
    Assigners:false,
    Sites:false,
    Templates:false,
  })
  const [searchText, setSearchText] = React.useState("");
  const [scheduleLoader, setScheduleLoader] = React.useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [datesFilters, setDateFilters] = React.useState({
    today: false,
    yesterday: false,
    last7: false,
    last15: false,
    lastMonth: false,
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  console.log("selectedUsers((((************************************************",selectedUsers)


  

  React.useEffect(
    () => {
      fetchSchedule();
      getUsers();
      getTemplates();
      getSites();
      getGroups();
    },
    [company?.id]
  );

  const fetchSchedule = (_selectedTemplates,_selectedAssigners,_selectedSites,_selectedUsers,clearGroup) => {
    let _assignees = _selectedUsers == undefined ? selectedUsers : _selectedUsers;

    let selectedGroupUsers = groups.filter(item => selectedGroup.includes(item.id)).map(subItem => subItem.user_id.map(user => user.id)).flat()

    if(!clearGroup){  
      _assignees = [..._assignees, ...selectedGroupUsers]
    }
    
    
    setScheduleLoader(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      skip:0,
      limit:15,
      company_id: company.id,
      created_by: data.user_id,
      template:JSON.stringify(_selectedTemplates == undefined ? selectedTemplates : _selectedTemplates),
      assigned_by:JSON.stringify(_selectedAssigners == undefined ? selectedAssigners : _selectedAssigners),
      sites:JSON.stringify(_selectedSites == undefined ? selectedSites : _selectedSites),
      assignees:JSON.stringify(_assignees)
    };


    //console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Schedule/get_schedule_details_created_by?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          setTotalRecords(response.total_records)
          let sortedData = [];
          sortedData = response.data.sort(function(a, b) {
            return new Date(b.start_date) - new Date(a.start_date);
            //return moment(b.start_date).format("MMMM DD, YYYY") - moment(a.start_date).format("MMMM DD, YYYY")
          });

          
          setState({
            // ...state,
            Schedule: sortedData,
          });
          setScheduleLoader(false);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchSchedule(company);
          }
          setScheduleLoader(false);
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };

    const getGroups = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

      fetch(GlobalApi + "/companygroups/get_all_company_groups?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log("response of group",response);
          if (response.msg === "success") {
         setGroups(response.groups);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();

          if (status) {
            // console.log("opopopop");
            getUsers();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };


  const fetchMoreSchedule = (_selectedTemplates,_selectedAssigners,_selectedSites,_selectedUsers) => {
    let _assignees = _selectedUsers == undefined ? selectedUsers : _selectedUsers;

    let selectedGroupUsers = groups.filter(item => selectedGroup.includes(item.id)).map(subItem => subItem.user_id.map(user => user.id)).flat()


    _assignees = [..._assignees, ...selectedGroupUsers]

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      skip:state.Schedule.length,
      limit:15,
      company_id: company.id,
      created_by: data.user_id,
      template:JSON.stringify(_selectedTemplates == undefined ? selectedTemplates : _selectedTemplates),
      assigned_by:JSON.stringify(_selectedAssigners == undefined ? selectedAssigners : _selectedAssigners),
      sites:JSON.stringify(_selectedSites == undefined ? selectedSites : _selectedSites),
      assignees:JSON.stringify(_assignees)
    };


    //console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Schedule/get_schedule_details_created_by?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        //console.log(response, "{}{}{}{}");
        if (response.status === "Success") {
          setTotalRecords(response.total_records)
          let sortedData = [];
          sortedData = response.data.sort(function(a, b) {
            return new Date(b.start_date) - new Date(a.start_date);
            //return moment(b.start_date).format("MMMM DD, YYYY") - moment(a.start_date).format("MMMM DD, YYYY")
          });
          setState({
            // ...state,
            Schedule: [...state.Schedule, ...sortedData],
          });
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchSchedule(company);
          }
          setScheduleLoader(false);
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };


  const getUsers = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_entity?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          let arr = [];
          response.data.map((item) => {
            let obj = {
              first_name: item.first_name,
              last_name: item.last_name,
              id: item.id,
              checked: false,
            };
            arr.push(obj);
          });
          console.log("users??????????????????????????????????", arr);
          setAssignees(arr);
          setAssignedBy(arr);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();

          if (status) {
            // console.log("opopopop");
            getUsers();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };

  const getTemplates = async () => {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    var params = {
      company_id: company.id,
      user_id: data.user_id,
    };
    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(
      GlobalApi + "/TemplateShare/get_all_template_shares_for_user?" + query,
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          console.log(res.data);
          var result = res.data;
          var templateList = [];
          await result.map((data) => {
            var template = { id: data.id, name: data?.title, checked: false };
            templateList.push(template);
          });

          console.log(
            "templateList??????????????????????????????????",
            templateList
          );
          setTemplates(templateList);
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const getSites = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);

    let token = data.token;

    let params = { company_id: company.id };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch(GlobalApi + "/Region/get_all_regions?" + query, {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        let form = data.data;
        if (data.data.length > 0) {
          let arr = [];
          const data1 = data.data.map((value, index) => {
            value.Areas.map((area, i) => {
              area.Sites.map((sites, j) => {
                let obj = {
                  Site: sites?.title,
                  site_id: sites.id,
                  checked: false,
                };
                if (sites.status !== "deactivated") {
                  arr.push(obj);
                }
              });
            });
          });
          console.log("Sites??????????????????????????????????", arr);
          setSites(arr);
        }
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };

  const handleClick3 = (event) => {
    setFilterMenu1(event.currentTarget);
  };
  const handleClick4 = async (event) => {
    console.log("CLICK 4 >>>>>>>>>>>>>>>>> ", "ACCESS FILTER");
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(event.currentTarget);
  };
  const handleClick5 = async (event) => {
    console.log("CLICK 5 >>>>>>>>>>>>>>>>> ", "SHARED WITH FILTER");
    setFilterMenu2(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu3(event.currentTarget);
  };

  const handleClick6 = async (event) => {
    console.log("CLICK 5 >>>>>>>>>>>>>>>>> ", "SHARED WITH FILTER");
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu5(null);
    setFilterMenu4(event.currentTarget);
  };
  const handleClick7 = async (event) => {
    console.log("CLICK 5 >>>>>>>>>>>>>>>>> ", "SHARED WITH FILTER");
    setFilterMenu2(null);
    setFilterMenu4(null);
    setFilterMenu3(null);
    setFilterMenu5(event.currentTarget);
  };

  const handleClose3 = () => {
    setFilterMenu1(null);
  };

  const handleClose4 = () => {
    setFilterMenu2(null);
  };

  const handleClose5 = () => {
    setFilterMenu3(null);
  };

  const handleClose6 = () => {
    setFilterMenu4(null);
  };

  const handleClose7 = () => {
    setFilterMenu5(null);
  };

  const handleDone = (type) => {
    document.getElementById("schedule2Scroll").scrollTo(0, 0);
    fetchSchedule();
    setFilterMenu1(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(null);

    if(type == "Assignees"){
     if (selectedUsers.length > 0 || selectedGroup.length > 0) {
        setAppliedFilters({...appliedFilters,Assignees:true})
      }else{
        setAppliedFilters({...appliedFilters,Assignees:false})
      }
    }else if(type == "Assigners"){
      if(selectedAssigners.length > 0){
        setAppliedFilters({...appliedFilters,Assigners:true})
      }else{
        setAppliedFilters({...appliedFilters,Assigners:false})
      }
    }else if(type == "Templates"){
      if(selectedTemplates.length > 0){
        setAppliedFilters({...appliedFilters,Templates:true})
      }else{
        setAppliedFilters({...appliedFilters,Templates:false})
      }
    }else if(type == "Sites"){
      if(selectedSites.length > 0){
        setAppliedFilters({...appliedFilters,Sites:true})
      }else{
        setAppliedFilters({...appliedFilters,Sites:false})
      }
    }
  };

  const open = Boolean(filterMenu1);
  const open2 = Boolean(filterMenu2);
  const open3 = Boolean(filterMenu3);
  const open4 = Boolean(filterMenu4);
  const open5 = Boolean(filterMenu5);

  const selectUsers = (checked, item) => {
    const nextselectedusers = checked
    ? [...selectedUsers, item.id]
    : selectedUsers.filter((t) => t !== item.id);
    setSelectedUsers(nextselectedusers);
  };

  const selectAssignedBy = (checked, item) => {
    const nextselectedAssigners = checked
      ? [...selectedAssigners, item.id]
      : selectedAssigners.filter((t) => t !== item.id);
    setSelectedAssigners(nextselectedAssigners);
  };

  const selectTemplate = (checked, item) => {
    const nextselectedTemplate = checked
      ? [...selectedTemplates, item.id]
      : selectedTemplates.filter((t) => t !== item.id);
    setSelectedTemplates(nextselectedTemplate);
  };

  const selectSite = (checked, item) => {
    const nextselectedSite = checked
      ? [...selectedSites, item.site_id]
      : selectedSites.filter((t) => t !== item.site_id);
    setSelectedSites(nextselectedSite);
  };

  const selectGroups = (checked, item) => {
    const nextselectedGroup = checked
      ? [...selectedGroup, item.id]
      : selectedGroup.filter((t) => t !== item.id);
    setSelectedGroups(nextselectedGroup);
  };
  
  const clearTemplateFilter = () => {
    setSelectedTemplates([]);
    document.getElementById("schedule2Scroll").scrollTo(0, 0);
    fetchSchedule([],selectedAssigners,selectedSites,selectedUsers);
    setFilterMenu1(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(null);
  };

  const clearSitesFilter = () => {
    setSelectedSites([]);
    document.getElementById("schedule2Scroll").scrollTo(0, 0);
    fetchSchedule(selectedTemplates,selectedAssigners,[],selectedUsers);
    setFilterMenu1(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(null);
  };

  const clearAssigneesFilter =async () => {
    await setSelectedUsers([]);
    document.getElementById("schedule2Scroll").scrollTo(0, 0);
    fetchSchedule(selectedTemplates,selectedAssigners,selectedSites,[]);
    setFilterMenu1(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(null);
  };

  const clearGroupFilter =async () => {
    await setSelectedGroups([]);
    document.getElementById("schedule2Scroll").scrollTo(0, 0);
    fetchSchedule(selectedTemplates,selectedAssigners,selectedSites,[],true);
    setFilterMenu1(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(null);
  };

  const clearAssignedByFilter = () => {
    setSelectedAssigners([]);
    document.getElementById("schedule2Scroll").scrollTo(0, 0);
    fetchSchedule(selectedTemplates,[],selectedSites,selectedUsers);
    setFilterMenu1(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(null);
  };

  const handleScroll = (e) =>{
    let currentRecords = state.Schedule.length;
    const bottom = e.target.scrollHeight - Math.ceil(e.target.scrollTop) === e.target.clientHeight;
    if(bottom){
      if(currentRecords < totalRecords){
      fetchMoreSchedule();
      }
    }
  }

  return <>
      <Grid container justifyContent="space-between" alignItems="center" style={{ backgroundColor: "white", padding: "5px 20px",width:'100%', justifyContent:'space-between', borderRadius: "5px", marginTop: "10px" }}>
        <Grid item xs={12} sm={12} md={4} style={{alignItems:'center', display:'flex'}}>
          <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                  <img src={search} width={12} />
                </InputAdornment>, endAdornment: <InputAdornment position="end">
                  <Tooltip title={t("Filter Options")}>
                    <img src={filter} width={20} style={{ cursor: "pointer" }} onClick={handleClick3} />
                  </Tooltip>
                </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search in existing Schedules")} fullWidth onChange={(e) => setSearchText(e.target.value)} variant="outlined" style={{ width: "77%", backgroundColor: Colors.globalColor5 }} />
                
                <Tooltip title="Help">
                
                <a href="https://www.uraudits.com/knowledge-center/schedules/" target="blank" style={{color:Colors.globalColor8}}>
                <img src={language == "ar" ? helpAr : help} height={25} style={{marginLeft:'5px',marginTop:'5px'}}/>
                  </a>
               
              </Tooltip>

          {/* =================================popover 1=========================== */}

          <Popover open={open} anchorEl={filterMenu1} onClose={handleClose3} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} transformOrigin={{ vertical: "top", horizontal: "center" }}>
            <div style={{ width: "150px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "0px" }}>
              <List component="nav" aria-label="secondary mailbox folders">
                <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px",textAlign:language == "ar" ? "right" : "left" }} onClick={(e) => handleClick4(e)}>
                <ListItemText primary={t("Assignee/Groups")} />
                </ListItem>
                <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px",textAlign:language == "ar" ? "right" : "left" }} onClick={(e) => handleClick7(e)}>
                  <ListItemText primary={t("Assigned by")} />
                </ListItem>
                <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px",textAlign:language == "ar" ? "right" : "left" }} onClick={(e) => handleClick5(e)}>
                  <ListItemText primary={t("Templates")} />
                </ListItem>
                <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px" ,textAlign:language == "ar" ? "right" : "left" }} onClick={(e) => handleClick6(e)}>
                  <ListItemText primary={t("Site")} />
                </ListItem>
              </List>
            </div>
          </Popover>

          {/* =================================popover 2=========================== */}
          <Popover open={open2} anchorEl={filterMenu2} onClose={handleClose4} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
            <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
              <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                      <img src={search} width={12} />
                    </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search")} fullWidth variant="outlined" style={{ backgroundColor: Colors.globalColor5 }} value={userFilter} onChange={(e) => setUserFilter(e.target.value)} />

              <br />
              <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                {t("Assignees")}
              </p>
              <div className="scrollbarShow2" style={{ maxHeight: "100px", overflowY: "scroll" }}>
                {Assignees.filter((word) => word.first_name
                      .toLowerCase()
                      .includes(
                        userFilter.toLowerCase()
                      ) || word.last_name
                      .toLowerCase()
                      .includes(
                        userFilter.toLowerCase()
                      ) || (word.first_name + " " + word.last_name)
                      .toLowerCase()
                      .includes(
                        userFilter.toLowerCase()
                      )).map((item, index) => {
                  return <span style={{ display: "block" }}>
                      <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} onChange={(e) => selectUsers(e.target.checked, item)}  defaultChecked={selectedUsers.indexOf(item.id) > -1}  />
                      <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                        {item.first_name}
                      </p>
                      &nbsp;
                      <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                        {item.last_name}
                      </p>
                    </span>;
                })}
              </div>

              <p
                    className="label2"
                    style={{
                      marginTop: "10px",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    {t("Groups")}
                  </p>
                  <div
                    className="scrollbarShow2"
                    style={{ maxHeight: "100px", overflowY: "scroll" }}
                  >
                    {groups.filter(
                      (word) =>
                        word.group_name
                          .toLowerCase()
                          .includes(userFilter.toLowerCase()) 
                    ).map((item, index) => {
                      return (
                        <span style={{ display: "block" }}>
                          <Checkbox
                            className="filterCheckbox"
                            style={{ color: Colors.globalColor8 }}
                            onChange={(e) =>
                              selectGroups(e.target.checked, item)
                            }
                            defaultChecked={selectedGroup.indexOf(item.id) > -1}
                          />
                          <p
                            className="label2"
                            style={{
                              display: "inline",
                              marginTop: "0px",
                              fontSize: 12,
                              textTransform: "capitalize",
                              fontWeight: "normal",
                            }}
                          >
                            {item.group_name}
                          </p>
                       
                        </span>
                      );
                    })}
                  </div>

              <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
              <Button className="ctBtn" onClick={() => handleDone("Assignees")}>
                {t("Done")}
              </Button>
            </div>
          </Popover>

          {/* =================================popover 3=========================== */}
          <Popover open={open3} anchorEl={filterMenu3} onClose={handleClose5} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
            <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
              <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                      <img src={search} width={12} />
                    </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search")} fullWidth variant="outlined" style={{ backgroundColor: Colors.globalColor5 }} value={templateFilter} onChange={(e) => setTemplateFilter(e.target.value)} />

              <br />
              <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                {t("Templates")}
              </p>
              <div className="scrollbarShow2" style={{ maxHeight: "100px", overflowY: "scroll" }}>
                {templates
                  .filter((word) =>
                    word.name
                      .toLowerCase()
                      .includes(templateFilter.toLowerCase())
                  ).sort((a, b) => a.name.localeCompare(b.name))
                  .map((item, index) => {
                    if(item.name){
                      return <span style={{ display: "block" }}>
                      <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} onChange={(e) => selectTemplate(e.target.checked, item)} defaultChecked={selectedTemplates.indexOf(item.id) > -1} />
                      <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                        {item.name}
                      </p>
                    </span>;
                    }
                    
                  })}
              </div>

              <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
              <Button className="ctBtn" onClick={() => handleDone("Templates")}>
                {/* //  onClick={() => onSelectUser()} */}
                {t("Done")}
              </Button>
            </div>
          </Popover>

          {/* =================================popover 4=========================== */}
          <Popover open={open4} anchorEl={filterMenu4} onClose={handleClose6} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
            <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
              <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                      <img src={search} width={12} />
                    </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search")} fullWidth variant="outlined" style={{ backgroundColor: Colors.globalColor5 }} value={siteFilter} onChange={(e) => setSiteFilter(e.target.value)} />

              <br />
              <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                {t("Site")}
              </p>
              <div className="scrollbarShow2" style={{ maxHeight: "100px", overflowY: "scroll" }}>
                {sites
                  .filter((word) =>
                    word.Site.toLowerCase().includes(siteFilter.toLowerCase())
                  ).sort((a, b) => a.Site.localeCompare(b.Site))
                  .map((item, index) => {
                    return <span style={{ display: "block" }}>
                        <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} onChange={(e) => selectSite(e.target.checked, item)} defaultChecked={selectedSites.indexOf(item.site_id) > -1} />
                        <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                          {item.Site}
                        </p>
                      </span>;
                  })}
              </div>

              <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
              <Button className="ctBtn" onClick={() => handleDone("Sites")}>
                {/* //  onClick={() => onSelectUser()} */}
                {t("Done")}
              </Button>
            </div>
          </Popover>

          {/* =================================popover 5=========================== */}
          <Popover open={open5} anchorEl={filterMenu5} onClose={handleClose7} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
            <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
              <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                      <img src={search} width={12} />
                    </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search")} fullWidth variant="outlined" style={{ backgroundColor: Colors.globalColor5 }} value={assignedByFilter} onChange={(e) => setAssignedByFilter(e.target.value)} />

              <br />
              <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                {t("Assigned by")}
              </p>
              <div className="scrollbarShow2" style={{ maxHeight: "100px", overflowY: "scroll" }}>
                {AssigneBy.filter((word) => word.first_name
                      .toLowerCase()
                      .includes(
                        assignedByFilter.toLowerCase()
                      ) || word.last_name
                      .toLowerCase()
                      .includes(
                        assignedByFilter.toLowerCase()
                      ) || (word.first_name + " " + word.last_name)
                      .toLowerCase()
                      .includes(
                        assignedByFilter.toLowerCase()
                      )).map((item, index) => {
                  return <span style={{ display: "block" }}>
                      <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} onChange={(e) => selectAssignedBy(e.target.checked, item)} defaultChecked={selectedAssigners.indexOf(item.id) > -1} />
                      <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                        {item.first_name}
                      </p>
                      &nbsp;
                      <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                        {item.last_name}
                      </p>
                    </span>;
                })}
              </div>

              <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
              <Button className="ctBtn" onClick={() => handleDone("Assigners")}>
                {t("Done")}
              </Button>
            </div>
          </Popover>
        </Grid>
        {(appliedFilters.Assignees || appliedFilters.Templates || appliedFilters.Assigners || appliedFilters.Sites) && <Grid item xs={12} sm={12} md={6}>
        <div className="scrollHidden2" style={{ overflowX: "scroll", whiteSpace: "nowrap", display: "flex", width: "100%", paddingBottom: "5px" }}>
            {selectedTemplates.length > 0 && appliedFilters.Templates && <div style={{ backgroundColor: Colors.globalColor9, justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                  <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px" }}>
                    {" "}
                    {templates
                      .filter((v) => v.id == selectedTemplates[0])[0]
                      .name.slice(
                        0,
                        20
                      ) + "..."} {selectedTemplates.length > 1 && <>
                        {" "}
                        +{selectedTemplates.length - 1}{" "}
                      </>}
                  </div> <div onClick={() => clearTemplateFilter()} style={{ display: "inline", padding: "0px 5px", cursor: "pointer" }}>
                    x
                  </div>
                </div>
              </div>}
            &nbsp;
            {selectedUsers.length > 0 && appliedFilters.Assignees && <div style={{ backgroundColor: Colors.globalColor9, justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                  <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px" }}>
                    {/* {Assignees.filter((v) => v.id == selectedUsers)[0].first_name} */}

                    {/* Filter Assignees +{selectedUsers.length} */}
                    {Assignees.filter((v) => v.id == selectedUsers[0])[0].first_name} {selectedUsers.length > 1 && <>
                        {" "}
                        +{selectedUsers.length - 1}{" "}
                      </>}
                  </div> <div onClick={() => clearAssigneesFilter()} style={{ display: "inline", padding: "0px 5px", cursor: "pointer" }}>
                    x
                  </div>
                </div>
              </div>}
            &nbsp;
            {selectedGroup.length > 0 && appliedFilters.Assignees && <div style={{ backgroundColor: Colors.globalColor9, justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                  <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px" }}>
                  {
                            groups.filter((v) => v.id == selectedGroup[0])[0]
                              .group_name
                          }{" "}
                          {selectedGroup.length > 1 && (
                            <> +{selectedGroup.length - 1} </>
                          )}
                  </div> <div onClick={() => clearGroupFilter()} style={{ display: "inline", padding: "0px 5px", cursor: "pointer" }}>
                    x
                  </div>
                </div>
              </div>}
            &nbsp;
            {selectedAssigners.length > 0 && appliedFilters.Assigners && <div style={{ backgroundColor: Colors.globalColor9, justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                  <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px" }}>
                    {AssigneBy.filter((v) => v.id == selectedAssigners[0])[0].first_name} {selectedAssigners.length > 1 && <>
                        {" "}
                        +{selectedAssigners.length - 1}{" "}
                      </>}
                    {/* Filter AssignedBy +{selectedAssigners.length} */}
                  </div> <div onClick={() => clearAssignedByFilter()} style={{ display: "inline", padding: "0px 5px", cursor: "pointer" }}>
                    x
                  </div>
                </div>
              </div>}
            &nbsp;
            {selectedSites.length > 0 && appliedFilters.Sites && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                  <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px" }}>
                    {sites.filter((v) => v.site_id == selectedSites[0])[0].Site} {selectedSites.length > 1 && <>
                        {" "}
                        +{selectedSites.length - 1}{" "}
                      </>}
                  </div> <div onClick={() => clearSitesFilter()} style={{ display: "inline", padding: "0px 5px", cursor: "pointer" }}>
                    x
                  </div>
                </div>
              </div>}
          </div>
        </Grid>}
        
        <Grid item xs={12} sm={12} md={2} style={{ textAlign:window.innerWidth > 700 ? (language == "ar"?"left":"right") : "center"}}>
                    {searchText == "" && <p className="label2" style={{ textAlign:window.innerWidth > 700 ? (language == "ar"?"left":"right") : "center",display: "inline", marginTop: 8, fontSize: 12, color: "grey", textTransform: "capitalized" }}>
                        {t("showing records")} {state.Schedule.length} {t("of")} {totalRecords}
                      </p>}
                  </Grid>
    
      </Grid>

      <div style={{ height: "70vh", padding:window.innerWidth > 500 ? "0px 10px 10px 10px" : "5px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <div className="scrollbarShow2" id="schedule2Scroll" style={{ overflowY: "scroll" }} onScroll={(e) => handleScroll(e)}>
          <Filters state={state} setState={setState} scheduleLoader={scheduleLoader} searchText={searchText} handleScroll={handleScroll} groups={groups} />
        </div>
      </div>
    </>;
}

export default Schedulemanage;



